var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{attrs:{"data-testid":"attachment-list","items":_vm.sortedItems,"empty-message":_vm.$t('no_attachments_exist'),"list-item":_vm.AttachmentListItem}},[_vm._t("top",null,{"slot":"top"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }